import { Buffer } from "buffer"

import axios from "axios"

import { BaseHttpProvider } from "./base-http.provider"

export class MediaProvider extends BaseHttpProvider {
  async parseTeamAnimation(animation: string): Promise<string> {
    try {
      return await this.execute({ uri: animation }, "")
    } catch {
      return ""
    }
  }

  getBinary = async (url: string) => {
    try {
      return await axios
        .request({
          method: "GET",
          url,
          responseType: "arraybuffer",
        })
        .then((response) => {
          const buffer = Buffer.from(response.data, "binary")
          return buffer
        })
    } catch (err) {
      if (err) return null
    }
  }
}
